module.exports = __webpack_public_path__ + "static/concept-61e02a64da0d6d0379fd9df7a0c65181.png";